import { ResponseMessage } from "../clients/response-message";

export class NotFoundError extends Error {
    readonly response: ResponseMessage;

    constructor(message: string, response: ResponseMessage) {
        super(message);
        Object.setPrototypeOf(this, new.target.prototype);

        this.response = response;
    }
}
